import React from "react";

const AnchorLeft = ({
  textElement,
  layerId,
  anchor_point,
  itemType,
  handeUpdateAnchorPoint,
}) => {
  const onUpdateAnchorPoint = () => {
    handeUpdateAnchorPoint({
      id: textElement.id,
      layerId,
      anchor_point: "left",
      itemType,
    });
  };

  const enabled = anchor_point === "left" || !anchor_point ? "enabled" : "";

  return (
    <a
      className={`tool__option tool__option--align tool__option--align-left ${enabled}`}
      onClick={onUpdateAnchorPoint}
    >
      <div className="icon-align__icon">
        <div className="icon-align__svg">
          <svg
            className="icon-align icon-align__left"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 33.9 32"
            width="34"
            height="32"
          >
            <path className="icon-align__path" d="M.5 31.5V.5" />
            <path
              className="icon-align__path icon-align__path--wide"
              d="M32.9 12.5H8.5M32.9 26.5H8.5M24.5 19.5h-16M24.5 5.5h-16"
            />
          </svg>
        </div>
        <div className="icon-align__text">Left</div>
      </div>
    </a>
  );
};

export default AnchorLeft;
